<template>

  <v-layout wrap>

    <v-flex
      lg4
      md4
      sm12>
      <v-layout wrap>
        <v-flex
          lg12
          md12
          sm12
          xs12>
          <v-card>
            <div id="bar">
              <apexchart
                ref="ExamLogGraph"
                :options="lectureWatchedOptions"
                :series="lectureWatchedSeries"
                type="bar"
              />
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex
      lg8
      md8
      sm12>
      <v-layout wrap>
        <v-flex
          lg6
          md6
          sm12>
          <v-card>
            <div id="chart">
              <apexchart
                ref="deviceGraph"
                :options="options"
                :series="series"
                type="bar"
              />
            </div>
          </v-card>

        </v-flex>
        <v-flex
          lg6
          md6
          sm12>
          <v-card>
            <div id="chart">
              <apexchart
                ref="UserLogGraph"
                :options="userLogOptions"
                :series="userLogSeries"
                type="line"
              />
            </div>
          </v-card>
        </v-flex>

        <v-flex
          lg6
          md6
          sm12>
          <v-card>
            <div id="chart">
              <apexchart
                ref="VideoLogGraph"
                :options="videoLogOptions"
                :series="videoLogSeries"
                type="line"
              />
            </div>
          </v-card>
        </v-flex>
        <v-flex
          lg6
          md6
          sm12>
          <v-card>
            <div id="chart">
              <apexchart
                ref="ExamLogGraph"
                :options="examLogOptions"
                :series="examLogSeries"
                type="line"
              />
            </div>
          </v-card>
        </v-flex>

        <v-flex
          lg12
          md12
          sm12
          xs12>
          <v-card>
            <div id="chart">
              <apexchart
                :options="topVideoChartOptions"
                :series="topVideoSeries"
                type="bar"
              />
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import firebase from 'firebase/app'
import bus from '../bus'
import { deviceRef, userSessionRef, streamingVideosRef, activeUserRef, videoLogRef, examLogRef, activeExamRef } from '../firebase'
import { setTimeout } from 'timers'
import { mapGetters, mapActions, mapState } from 'vuex'

import Pusher from 'pusher-js'
const socket = new Pusher('8b7b2278694ce750e2e5', {
  cluster: 'mt1',
  encrypted: true
})
const channel = socket.subscribe('newLecture')
const channelViewLecture = socket.subscribe('viewLecture')

export default {

  components: {
    apexchart: VueApexCharts
  },
  firebase: {
    devices: deviceRef
  },

  computed: {
    ...mapGetters('dashboard', ['lastDayVideoCount']),
    ...mapState('dashboard', ['usersList', 'lectureCountList', 'courseList', 'lectureOption', 'lectureSeries', 'subjectOption', 'subjectSeries', 'liveStreamingNumber', 'lastDayExamCount', 'currentlyExamParticipant', 'activeUserNumber', 'topVideoSeries', 'topVideoChartOptions'])
  },
  data () {
    return {
      currentExamPerticipationList: [],
      devices: [],
      valueLive: [],
      dateList: [],
      users: [],
      usersLog: [],
      streamingVideos: [],
      userLogSeries: [],
      userLogOptions: {},
      videoLogSeries: [],
      videoLogOptions: {},
      examLogSeries: [],
      examLogOptions: {},
      currentExamList: [],
      lectureWatchedSeries: [],
      lectureWatchedOptions: {},
      options: {
        chart: {
          id: 'bar-chart'
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: ['Currently Watching Videos', 'Currently Exam Participants']
        },
        title: {
          text: 'User Engagement'
        }
      },
      series: [
        {
          name: 'Total Live Streaming',
          data: []
        }
      ],

      pie_series: [45, 55, 70],
      chartOptions: {
        labels: ['Female', 'Male', 'Not mentioned' ],
        theme: {
          monochrome: {
            enabled: true
          }
        },
        title: {
          text: 'Number of leads'
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      isReady: false
    }
  },
  watch: {
    liveStreamingNumber: function (val) {
      let seriesData = this.series[0].data
      seriesData[0] = val

      this.$refs.deviceGraph.updateSeries([
        {
          data: seriesData
        }
      ])
    },
    currentlyExamParticipant: function (val) {
      let seriesData = this.series[0].data
      seriesData[1] = val

      this.$refs.deviceGraph.updateSeries([
        {
          data: seriesData
        }
      ])
    },
    activeUserNumber: function (val) {

    },
    lastDayExamCount: function (val) {
      let seriesData = this.examLogSeries[0].data
      seriesData[seriesData.length - 1] = Math.ceil(val / 2)
      this.$refs.ExamLogGraph.updateSeries([
        {
          data: seriesData
        }
      ])
    }
  },
  created () {
    let self = this
    channelViewLecture.bind('lecture-viewed', function (data) {
      self.getTodayVideos()
    })
    this.getFirebaseData()
    this.getFirebaseDataFromStore()
    this.getUserLog()
    this.getVideoLog()
    this.getExamLog()
    this.onExamLogChildChange()
    this.getTodayVideos()
  },
  methods: {
    ...mapActions('dashboard', [ 'getFirebaseDataFromStore', 'getTodayVideos', 'setLiveStreamingNumber', 'getUserAndLecture', 'getUserNameByIdArray']),

    getFirebaseData () {
      let self = this
      this.streamingVideos = []
      this.currentExamList = []
      deviceRef.on('child_added', snapshot => {
        let val = snapshot.val()
        this.devices.push({ ...val })
      })
      userSessionRef.on('child_added', snapshot => {
        let val = snapshot.val()
        this.users.push({ ...val })
      })

      let count = 0
      streamingVideosRef.on('child_added', snapshot => {
        if (count === 0) {
          this.getTodayVideos()
        }
        count++
        let val = snapshot.val()
        let videoInfo = val[Object.keys(val)[0]]
        if (videoInfo.playing) { self.streamingVideos.push(videoInfo) }
      })

      streamingVideosRef.on('child_removed', snapshot => {
        this.getVideoLog()
        // let val = snapshot.val();
        // let videoInfo = val[Object.keys(val)[0]]
        // self.streamingVideos.splice(self.streamingVideos.indexOf(videoInfo), 1);
      })

      videoLogRef.on('child_changed', snapshot => {
        this.getVideoLog()
      })
      activeUserRef.on('child_changed', snapshot => {
        this.getUserLog()
      })

      this.series[0].data.push(self.streamingVideos.length, this.currentExamList.length)
    },
    getUserLog () {
      this.dateList = []
      this.usersLog = []
      activeUserRef.limitToLast(10).on('child_added', snapshot => {
        console.log('add')
        let val = snapshot.val()
        // this.usersLog.push(val[Object.keys(val)]);
        this.usersLog.push(Object.keys(val).length)

        let date = new Date(snapshot.key)
        let dateString = date.toString().split(' ')
        this.dateList.push(dateString[1] + ' ' + dateString[2] + ' ' + dateString[3])
      })

      let options = {
        chart: {
          id: 'bar-chart'
        },
        xaxis: {
          categories: this.dateList
        },
        title: {
          text: 'User Login History'
        }
      }
      let series = [
        {
          name: 'Active user',
          data: this.usersLog
        }
      ]
      this.userLogOptions = options
      this.userLogSeries = series
    },
    sortDuration (durations, names) {
      return new Promise((resolve, reject) => {
        let tempValue = 0
        let tempName = 0
        for (let i = 0; i < durations.length; i++) {
          for (let j = i + 1; j < durations.length; j++) {
            if (durations[i] < durations[j]) {
              tempValue = durations[i]
              durations[i] = durations[j]
              durations[j] = tempValue

              tempName = names[i]
              names[i] = names[j]
              names[j] = tempName
            }
          }
        }
        resolve({
          'series': durations,
          'labels': names
        })
      })
    },
    getVideoStreamingDetailsWithUser (videoLog) {
      let barSeries = []
      let labels = []
      let indexes = Object.keys(videoLog)
      console.log(indexes)
      this.getUserNameByIdArray(indexes).then(response => {
        response.forEach(item => {
          labels.push(item.name)
        })
        indexes.forEach(item => {
          let singleUserHistory = videoLog[item]
          let historyIndexes = Object.keys(singleUserHistory)
          let watchedDurationSum = 0
          historyIndexes.forEach(hIndex => {
            let details = singleUserHistory[hIndex]
            watchedDurationSum += details.played_duration_in_second
          })
          barSeries.push(watchedDurationSum)
          // let obj = {
          //   'user_id': parseInt(item),
          //   'watchedTime': watchedDurationSum
          // }
        })
        this.sortDuration(barSeries, labels).then(response => {
          let series = [
            {
              name: 'Seconds',
              data: response.series
            }
          ]
          this.lectureWatchedSeries = series
          this.lectureWatchedOptions = {
            yaxis: {
              labels: {
                show: false
              }
            },
            chart: {
              height: 700
            },
            labels: response.labels,
            theme: {
              palette: 'palette5',
              monochrome: {
                enabled: true
              }
            },
            title: {
              text: 'Today\'s Top Video Watchers',
              align: 'left',
              floating: true
            },

            dataLabels: {
              enabled: true,
              textAnchor: 'start',
              style: {
                colors: ['#000'],
                textAlign: ['left']
              },
              formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + parseInt(val / 60) + ' Minutes ' + (val % 60) + ' (Seconds)'
              },
              offsetX: 0,
              offsetY: 0,
              dropShadow: {
                enabled: false,
                top: 1,
                left: 1,
                blur: 1,
                opacity: 0.45
              }
            },
            plotOptions: {
              bar: {
                barHeight: '90%',
                distributed: false,
                horizontal: true
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'left'
                  }
                }
              }
            ]
          }
        })
      })
    },
    getVideoLog () {
      let videoLog = []
      let videoCountLog = []
      let dateList = []
      videoLogRef.limitToLast(10).on('child_added', snapshot => {
        let val = snapshot.val()
        videoLog.push({ ...val })

        let date = new Date(snapshot.key)
        let dateString = date.toString().split(' ')
        dateList.push(dateString[1] + ' ' + dateString[2] + ' ' + dateString[3])
        // dateList.push(snapshot.key)
      })
      dateList.forEach((item, index) => {
        let date = new Date(item)
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        if (date.toString() === today.toString()) {
          this.getVideoStreamingDetailsWithUser(videoLog[index])
        }
      })
      // console.log(videoLog)
      videoLog.forEach(element => {
        let subIndexList = Object.keys(element)

        let videoNumber = 0
        subIndexList.forEach(sub => {
          let vObj = element[sub]
          videoNumber += Object.keys(vObj).length
        })
        videoCountLog.push(videoNumber)
      })
      let options = {
        chart: {
          id: 'bar-chart'
        },
        xaxis: {
          categories: dateList
        },
        title: {
          text: 'Video Seeing Count'
        }
      }
      let series = [
        {
          name: 'Video View Count',
          data: videoCountLog
        }
      ]
      this.videoLogOptions = options
      this.videoLogSeries = series
    },
    getExamLog () {
      let self = this
      let examLog = []
      let examCountLog = []
      let dateList = []

      examLogRef.limitToLast(10).on('child_added', snapshot => {
        let val = snapshot.val()
        examLog.push({ ...val })
        let date = new Date(snapshot.key)
        let dateString = date.toString().split(' ')
        dateList.push(dateString[1] + ' ' + dateString[2] + ' ' + dateString[3])
      })
      let allChildren = []
      examLog.forEach(element => {
        let subIndexList = Object.keys(element)

        let examNumber = 0
        subIndexList.forEach(sub => {
          let vObj = element[sub]
          // console.log(element[sub])
          // console.log(vObj[Object.keys(vObj)])
          let keys = Object.keys(vObj)
          keys.forEach(k => {
            if (vObj[k].started_at) {
              allChildren.push(vObj[k])
            }
          })
          // console.log(Object.keys(vObj))
          examNumber += Math.floor(Object.keys(vObj).length / 2)
        })
        examCountLog.push(examNumber)
      })
      let options = {
        chart: {
          id: 'bar-chart'
        },
        xaxis: {
          categories: dateList
        },
        title: {
          text: 'Exam Participation History'
        }
      }
      let series = [
        {
          name: 'Exam Participation Count',
          data: examCountLog
        }
      ]
      this.examLogOptions = options
      this.examLogSeries = series

      let exams = []
    },
    onExamLogChildChange () {
      examLogRef.on('child_changed', snapshot => {
        this.getExamLog()
      })
    },
    sortByDate (dateList) {
      dateList.forEach(date => {
        console.log(Date.parse(date))
      })
    }
  }
}
</script>
